// extracted by mini-css-extract-plugin
export var button = "ConnectAppleButton-module__button___WTaMs";
export var disabled = "ConnectAppleButton-module__disabled___jAjyR";
export var loading = "ConnectAppleButton-module__loading___nCwTM";